var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.content)}}),_c('Reviews')],1)}
var staticRenderFns = []

export { render, staticRenderFns }